import Upload from './Upload';

export default Upload;
export * from './interface';
export { UploadContext } from './UploadContext';
